import React, { useEffect, useState } from 'react';
import styles from '../../../src/assets/scss/CreateOrders.module.scss';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../Components/Common/Pagination';
import {
  useCreateOrderMutation,
  useGetMyEmployeesQuery,
  useGetMyVendorsQuery,
  useGetOrderByIdQuery,
  useGetUserByIdQuery,
  useUpdateOrderMutation,
  useGetBillingCustomersQuery
} from '../../slices/admin/admin';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { getUserInfo } from '../../utils/user.util';
import { toast } from 'react-toastify';
import Select from 'react-select';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import AddItem from './AddItem';
import DeleteConfirmModalLogout from '../../Components/Common/DeleteConfirmModalLogout';

const CreateOrders = () => {
  const [effectiveDate, setEffectiveDate] = useState('');
  const [selectedStore, setSelectedStore] = useState('');
  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [orderItems, setOrderItems] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [deliveryOption, setDeliveryOption] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Customer selection states
  const [isCustomerOrder, setIsCustomerOrder] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [isAddingNewCustomer, setIsAddingNewCustomer] = useState(false);
  const [newCustomerName, setNewCustomerName] = useState('');
  const [newCustomerPhone, setNewCustomerPhone] = useState('');

  //console.log(orderItems, "orderItems345");



  const [showAddItemPopup, setShowAddItemPopup] = useState(false);
  const [popupProps, setPopupProps] = useState(null);



  const { data: empData } = useGetMyEmployeesQuery();
  const employees = empData?.result || [];

  const {
    data: customerData,
    isLoading: customerLoading,
    error: customerError,
  } = useGetBillingCustomersQuery();
  const predefinedCustomers = customerData?.items || [];

  //console.log(employees, "employees");

  const navigate = useNavigate();
  const location = useLocation();
  const viewOnly = location.state?.viewOnly || false;
  const orderIdToView = location.state?.orderId || null;


  const isUpdateMode = location.state?.updateMode || false;

  const [createOrder, { isLoading: isCreating }] = useCreateOrderMutation();
  const [updateOrder, { isLoading: isUpdating }] = useUpdateOrderMutation();
  const { data, isLoading: isVendorsLoading } = useGetMyVendorsQuery();
  const stores = data?.stores || [];

  const { data: viewOrderData, refetch: refetchOrder } = useGetOrderByIdQuery(orderIdToView, {
    skip: !orderIdToView || (!viewOnly && !isUpdateMode),
    refetchOnMountOrArgChange: true
  });

  useEffect(() => {
    // Log once when component mounts
    if (orderIdToView) {
      console.log(orderIdToView, "orderIdToView888");
    }
  }, [orderIdToView]);

  useEffect(() => {
    const loadOrderData = () => {
      if ((viewOnly || isUpdateMode) && orderIdToView && viewOrderData?.result?.[0]) {
        const order = viewOrderData.result[0];

        // AssignedTo
        setAssignedTo(order.assignedTo || '');

        // Set store details
        const matchedStoreId = order.store?._id || order.orderStore;
        if (matchedStoreId) {
          setSelectedStore(matchedStoreId);
          setSelectedVendorId(matchedStoreId);
        } else {
          toast.warn('Order store not found in vendor list');
          setSelectedStore('');
          setSelectedVendorId('');
        }

        // Preorder date
        setEffectiveDate(dayjs(order.date || order.preOrderDate).format('YYYY-MM-DD'));

        // Items
        const formattedItems = order.items?.map(item => {
          const bag = item.productBag || '';
          return {
            itemId: item._id,
            itemName: item.productName || '',
            productBag: bag,
            productType: item.productType || '',
            productQuantity: bag === 'kilogram' ? item.productQuantity || 0 : 0,
            productCount: bag !== 'kilogram' ? item.productCount || 0 : 0,
          };
        }) || [];


        setOrderItems(formattedItems);
      }
    };

    loadOrderData();
  }, [viewOrderData, orderIdToView, viewOnly, isUpdateMode]);

  useEffect(() => {
    if (selectedStore && stores.length > 0) {
      const vendor = stores.find(store => store._id === selectedStore);
      setSelectedVendorId(vendor ? vendor._id : '');
    }
  }, [selectedStore, stores]);

  useEffect(() => {
    if (!viewOnly && !isUpdateMode) {
      const storedStore = localStorage.getItem('selectedStore');
      const storedDate = localStorage.getItem('selectedDate');
      if (storedStore) setSelectedStore(storedStore);
      if (storedDate) setEffectiveDate(storedDate);
      const storedItems = JSON.parse(localStorage.getItem('orderItems') || '[]');
      setOrderItems(storedItems);
    }
  }, [viewOnly, isUpdateMode]);

  const user = getUserInfo();
  const userId = user?._id;
  const { data: profileData } = useGetUserByIdQuery(userId, { skip: !userId });
  const [userData, setUserData] = useState(null);



  useEffect(() => {
    if ((viewOnly || isUpdateMode) && viewOrderData?.result?.[0]) {
      const order = viewOrderData.result[0];
      setUserData({
        firstName: order.createdBy?.firstName || '',
        lastName: order.createdBy?.lastName || '',
        phone: order.createdBy?.phone || '',
        address: order.store?.address || 'N/A'
      });
    } else if (profileData?.result) {
      setUserData({
        firstName: profileData.result[0]?.firstName || '',
        lastName: profileData.result[0]?.lastName || '',
        phone: profileData.result[0]?.phone || '',
        address: profileData.result[0]?.store?.address || 'N/A'
      });
    }
  }, [viewOnly, isUpdateMode, viewOrderData, profileData]);



  const handleAddItem = () => {
    if (!isCustomerOrder && !selectedVendorId) {
      toast.error('Please select a store first');
      return;
    }

    if (isCustomerOrder && !selectedCustomer && !isAddingNewCustomer) {
      toast.error('Please select or add a customer first');
      return;
    }

    localStorage.setItem('selectedStore', selectedStore);
    localStorage.setItem('selectedDate', effectiveDate);

    setPopupProps({
      storeId: selectedVendorId,
      updateMode: isUpdateMode,
      viewOnly,
      orderId: orderIdToView,
    });
    setShowAddItemPopup(true);
  };

  // const handleQuantityChange = (index, value) => {
  //   const updatedItems = [...orderItems];
  //   updatedItems[index].quantity = value;
  //   setOrderItems(updatedItems);

  //   if (!viewOnly && !orderIdToView) {
  //     localStorage.setItem('orderItems', JSON.stringify(updatedItems));
  //   }
  // };


  const handleQuantityChange = (index, field, value) => {
    const updatedItems = [...orderItems];
    updatedItems[index][field] = value;
    setOrderItems(updatedItems);

    if (!viewOnly && !orderIdToView) {
      localStorage.setItem('orderItems', JSON.stringify(updatedItems));
    }
  };


  const handleDelete = (index) => {
    setSelectedDeleteIndex(index);
    setModalOpen(true);
  };

  const confirmDelete = () => {
    if (selectedDeleteIndex !== null) {
      const updatedItems = [...orderItems];
      updatedItems.splice(selectedDeleteIndex, 1);
      setOrderItems(updatedItems);
      localStorage.setItem('orderItems', JSON.stringify(updatedItems));
      setSelectedDeleteIndex(null);
      setModalOpen(false);
    }
  };

  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedItems = orderItems.slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(orderItems.length / itemsPerPage);
  const handlePageChange = (page) => setCurrentPage(page);

  const handleClose = () => {
    localStorage.removeItem('selectedStore');
    localStorage.removeItem('selectedDate');
    localStorage.removeItem('orderItems');
    navigate('/dashboard/Ordertable');
  };


  // const handleSave = async () => {
  //   try {


  //     const products = orderItems.map((item, index) => {

  //       const bag = item.productBag;
  //       const name = item.itemName || `Item ${index + 1}`;
  //       const quantity = Number(item.productQuantity);
  //       const count = Number(item.productCount);

  //       if (bag === 'kilogram') {
  //         if (!quantity || quantity < 1) {
  //           throw new Error(`${name}: Quantity must be ≥ 1.`);
  //         }
  //         return {
  //           // _id: item.itemId || null,
  //           productName: name,
  //           productType: item.productType,
  //           productBag: bag,
  //           productQuantity: quantity,
  //           productCount: 0,
  //         };
  //       } else {
  //         if (!count || count < 1) {
  //           throw new Error(`${name}: Count must be ≥ 1.`);
  //         }
  //         return {
  //           productName: name,
  //           productType: item.productType,
  //           productBag: bag,
  //           productQuantity: 0,
  //           productCount: count,
  //         };
  //       }
  //     });


  //     if (isUpdateMode && orderIdToView) {
  //       const updatePayload = {
  //         preOrderDate: effectiveDate,
  //         assignedTo,
  //         notes: 'extra delivery required',
  //         products,
  //         //_id: products.itemId || null,

  //       };

  //       await updateOrder({ id: orderIdToView, body: updatePayload }).unwrap();
  //       toast.success('Order updated successfully');
  //     } else {
  //       const createPayload = {
  //         preOrderDate: effectiveDate,
  //         deliveryOption,
  //         orderStore: selectedVendorId,
  //         notes: 'extra delivery required',
  //         products,
  //       };

  //       await createOrder(createPayload).unwrap();
  //       toast.success('Order created successfully');
  //     }

  //     localStorage.removeItem('orderItems');
  //     navigate('/dashboard/Ordertable');
  //   } catch (err) {
  //     toast.error(err?.message || err?.data?.message || 'Operation failed');
  //   }
  // };

  const handleSave = async () => {
    try {
      const products = orderItems.map((item, index) => {
        const bag = item.productBag;
        const name = item.itemName || `Item ${index + 1}`;
        const quantity = Number(item.productQuantity);
        const count = Number(item.productCount);

        const baseProduct = {
          productName: name,
          productType: item.productType,
          productBag: bag,
        };

        if (bag === 'kilogram') {
          if (!quantity || quantity < 1) {
            throw new Error(`${name}: Quantity must be ≥ 1.`);
          }
          baseProduct.productQuantity = quantity;
          baseProduct.productCount = 0;
        } else {
          if (!count || count < 1) {
            throw new Error(`${name}: Count must be ≥ 1.`);
          }
          baseProduct.productQuantity = 0;
          baseProduct.productCount = count;
        }

        if (isUpdateMode && item.itemId) {
          baseProduct._id = item.itemId;
        }

        return baseProduct;
      });

      if (isUpdateMode && orderIdToView) {
        const updatePayload = {
          preOrderDate: effectiveDate,
          assignedTo,
          notes: 'extra delivery required',
          products,
        };

        await updateOrder({ id: orderIdToView, body: updatePayload }).unwrap();
        toast.success('Order updated successfully');
      } else {
        const createPayload = {
          preOrderDate: effectiveDate,
          deliveryOption,
          orderStore: isCustomerOrder ? profileData?.result?.[0]?.store?._id : selectedVendorId,
          notes: 'extra delivery required',
          products,
        };

        if (isCustomerOrder) {
          createPayload.isOwnerCreate = true;
          if (isAddingNewCustomer) {
            createPayload.userName = newCustomerName;
            createPayload.phone = newCustomerPhone;
          } else {
            const customer = predefinedCustomers.find(c => c._id === selectedCustomer);
            if (customer) {
              createPayload.userName = customer.firstName || customer.userName || '';
              createPayload.phone = customer.phone || '';
            }
          }
        }

        await createOrder(createPayload).unwrap();
        toast.success('Order created successfully');
      }

      localStorage.removeItem('orderItems');
      localStorage.removeItem('selectedStore');
      localStorage.removeItem('selectedDate');
      //navigate('/dashboard/Ordertable');
      navigate("/dashboard/Ordertable?tab=myInvoice");
    } catch (err) {
      toast.error(err?.message || err?.data?.message || 'Operation failed');
    }
  };



  const handleEditItem = (index) => {
    const item = orderItems[index];
    if (!item?.itemId && isUpdateMode) {
      toast.error('Item ID missing');
      return;
    }

    setPopupProps({
      storeId: selectedVendorId,
      editIndex: index,
      itemData: item,
      updateMode: isUpdateMode,
      viewOnly,
      orderId: orderIdToView,
      itemId: item.itemId,
    });
    setShowAddItemPopup(true);
  };


  const storeOptions = stores.map(store => ({
    value: store._id,
    label: `${store.storeName}`
  }));



  // ✅ Separated confirm action
  const handleConfirmSave = async () => {
    setLoading(true);
    try {
      const products = orderItems.map((item, index) => {
        const bag = item.productBag;
        const name = item.itemName || `Item ${index + 1}`;
        const quantity = Number(item.productQuantity);
        const count = Number(item.productCount);

        const baseProduct = {
          productName: name,
          productType: item.productType,
          productBag: bag,
        };

        if (bag === 'kilogram') {
          if (!quantity || quantity < 1) {
            throw new Error(`${name}: Quantity must be ≥ 1.`);
          }
          baseProduct.productQuantity = quantity;
          baseProduct.productCount = 0;
        } else {
          if (!count || count < 1) {
            throw new Error(`${name}: Count must be ≥ 1.`);
          }
          baseProduct.productQuantity = 0;
          baseProduct.productCount = count;
        }

        if (isUpdateMode && item.itemId) {
          baseProduct._id = item.itemId;
        }

        return baseProduct;
      });

      if (isUpdateMode && orderIdToView) {
        const updatePayload = {
          preOrderDate: effectiveDate,
          assignedTo,
          notes: 'extra delivery required',
          products,
        };

        await updateOrder({ id: orderIdToView, body: updatePayload }).unwrap();
        toast.success('Order updated successfully');
      } else {
        const createPayload = {
          preOrderDate: effectiveDate,
          deliveryOption,
          orderStore: isCustomerOrder ? profileData?.result?.[0]?.store?._id : selectedVendorId,
          notes: 'extra delivery required',
          products,
        };

        if (isCustomerOrder) {
          createPayload.isOwnerCreate = true;
          if (isAddingNewCustomer) {
            createPayload.userName = newCustomerName;
            createPayload.phone = newCustomerPhone;
          } else {
            const customer = predefinedCustomers.find(c => c._id === selectedCustomer);
            if (customer) {
              createPayload.userName = customer.firstName || customer.userName || '';
              createPayload.phone = customer.phone || '';
            }
          }
        }

        await createOrder(createPayload).unwrap();
        toast.success('Order created successfully');
      }

      localStorage.removeItem('orderItems');
      localStorage.removeItem('selectedStore');
      localStorage.removeItem('selectedDate');
      navigate("/dashboard/Ordertable");
    } catch (err) {
      toast.error(err?.message || err?.data?.message || 'Operation failed');
    } finally {
      setLoading(false);
      setConfirmModalOpen(false);
    }
  };

  // ✅ When user clicks Save button → open confirm popup
  const handleSaveClick = () => {
    setConfirmModalOpen(true);
  };

  const handleCancelNewCustomer = () => {
    setIsAddingNewCustomer(false);
    setNewCustomerName('');
    setNewCustomerPhone('');
  };

  return (
    <div className={styles.createOrdersContainer}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>{viewOnly ? 'View Order' : isUpdateMode ? 'Update Order' : 'Create Orders'}</h2>
        <span className={styles.closeIcon} onClick={handleClose}>✕</span>
      </div>

      <div className={styles.containers}>
        <div className={styles.formSection}>
          <div className={styles.formLeft}>
            {!(viewOnly || isUpdateMode) && (
              <>
                {user?.type === 'wholesaleowner' && (
                  <div className={styles.inputGroup}>
                    <label className={styles.checkboxLabel}>
                      <input
                        type="checkbox"
                        checked={isCustomerOrder}
                        onChange={(e) => {
                          setIsCustomerOrder(e.target.checked);
                          if (e.target.checked) {
                            setSelectedStore('');
                            setSelectedVendorId('');
                          } else {
                            setSelectedCustomer('');
                            setIsAddingNewCustomer(false);
                            setNewCustomerName('');
                            setNewCustomerPhone('');
                          }
                        }}
                      />
                      Order for Customer
                    </label>
                  </div>
                )}

                {!isCustomerOrder ? (
                  <div className={styles.inputGroupss}>
                    <label className={styles.inputLabel}>Order Placed To</label>
                    <div className={styles.selectWrapper}>
                      <Select
                        className={styles.customSelect}
                        isDisabled={viewOnly}
                        styles={{
                          control: (base) => ({
                            ...base,
                            border: '1px solid #6D6D6D',
                            borderRadius: '6px',
                            fontSize: '16px',
                            minHeight: '50px',
                            boxShadow: 'none',
                            color: 'black',
                            fontWeight: '600',
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: '#6D6D6D',
                            fontSize: '16px',
                            fontWeight: '600',
                          }),
                        }}
                        value={storeOptions.find(option => option.value === selectedStore) || null}
                        onChange={(selectedOption) => setSelectedStore(selectedOption?.value)}
                        options={storeOptions}
                        placeholder="Select Store"
                        isSearchable
                      />
                    </div>
                  </div>
                ) : (
                  <div className={styles.inputGroupss}>
                    {!isAddingNewCustomer ? (
                      <>
                        <label className={styles.inputLabel}>Customer Name</label>
                        <Select
                          className={styles.customSelect}
                          isClearable
                          styles={{
                            control: (base) => ({
                              ...base,
                              border: '1px solid #6D6D6D',
                              borderRadius: '6px',
                              fontSize: '16px',
                              minHeight: '50px',
                              boxShadow: 'none',
                              color: 'black',
                              fontWeight: '600',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#6D6D6D',
                              fontSize: '16px',
                              fontWeight: '600',
                            }),
                          }}
                          value={
                            (() => {
                              const cust = predefinedCustomers.find((c) => c._id === selectedCustomer);
                              return cust
                                ? {
                                  value: selectedCustomer,
                                  label: `${cust.storeName ? `${cust.storeName} - ` : ""}${cust.phone} - ${cust.firstName || cust.userName} (Pending: ₹${cust.totalCreditAmount || 0})`,
                                }
                                : null;
                            })()
                          }
                          onChange={(selectedOption) =>
                            setSelectedCustomer(selectedOption ? selectedOption.value : '')
                          }
                          options={predefinedCustomers.map((cust) => ({
                            value: cust._id,
                            label: `${cust.storeName ? `${cust.storeName} - ` : ""}${cust.phone} - ${cust.firstName || cust.userName} (Pending: ₹${cust.totalCreditAmount || 0})`,
                          }))}
                          formatOptionLabel={(option) => {
                            const cust = predefinedCustomers.find(c => c._id === option.value);
                            if (!cust) return option.label;
                            const pendingAmount = cust.totalCreditAmount || 0;
                            return (
                                <span>
                                    {cust.storeName ? `${cust.storeName} - ` : ""}
                                    {cust.phone} - {cust.firstName || cust.userName}
                                    <span style={{ color: pendingAmount > 0 ? 'red' : 'inherit', marginLeft: '5px' }}>
                                        (Pending: ₹{pendingAmount})
                                    </span>
                                </span>
                            );
                          }}
                          placeholder={customerLoading ? 'Loading...' : 'Select Customer'}
                          isSearchable
                        />
                        {customerError && (
                          <p className={styles.error}>Failed to load customers.</p>
                        )}
                        {!selectedCustomer && (
                          <button
                            className={styles.addBtn}
                            style={{ marginTop: '6px' }}
                            onClick={() => {
                              setIsAddingNewCustomer(true);
                              setSelectedCustomer('');
                            }}
                          >
                            + New Customer
                          </button>
                        )}
                      </>
                    ) : (
                      <div className={styles.newCustomerContainer}>
                        <label className={styles.inputLabel}>Customer Name</label>
                        <input
                          className={styles.inputssss}
                          type="text"
                          placeholder="Enter Customer Name"
                          value={newCustomerName}
                          onChange={(e) => {
                            let value = e.target.value;
                            if (value.length === 1 && value[0] === ' ') return;
                            setNewCustomerName(value);
                          }}
                          onKeyDown={(e) => {
                            if ((e.key === ' ' || e.key === 'Spacebar') && newCustomerName.length === 0) {
                              e.preventDefault();
                            }
                          }}
                        />

                        <label className={styles.inputLabel}>Phone Number</label>
                        <input
                          className={styles.inputssss}
                          type="text"
                          placeholder="Enter Phone Number"
                          value={newCustomerPhone}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            if (value.length <= 10) {
                              setNewCustomerPhone(value);
                            }
                          }}
                          onBlur={() => {
                            if (newCustomerPhone.length !== 10 && newCustomerPhone.length > 0) {
                              toast.error('Phone number must be exactly 10 digits.');
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === ' ' || e.key === 'Spacebar') {
                              e.preventDefault();
                            }
                          }}
                        />

                        <div className={styles.buttonGroup}>
                          <button
                            className={styles.addBtn}
                            onClick={handleCancelNewCustomer}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
            {/* 
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Pre Order Date</label>
              <DatePicker
                disabled={viewOnly}
                selected={effectiveDate ? dayjs(effectiveDate, 'YYYY-MM-DD').toDate() : null}
                onChange={(date) => setEffectiveDate(dayjs(date).format('YYYY-MM-DD'))}
                dateFormat="MM.dd.yyyy"
                minDate={new Date()}
                placeholderText="Select date"
                className={styles.input}
                wrapperClassName={styles.fullWidthDatepicker}
              />
            </div>


         

            {(isUpdateMode || viewOnly) && user?.type !== 'employee' && (
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Assigned To</label>
                <select
                  className={styles.inputs}
                  value={assignedTo}
                  onChange={(e) => setAssignedTo(e.target.value)}
                  disabled={viewOnly}
                >
                  <option value="">Select Employee</option>
                  {employees.map(emp => (
                    <option key={emp._id} value={emp._id}>
                      {emp.userName}
                    </option>
                  ))}
                </select>
              </div>
            )} */}

            {viewOnly ? (
              // 👇 Show this only in VIEW mode
              <div className={styles.formRight}>
                <p>
                  <strong>Pre Order Date:</strong>{" "}
                  {effectiveDate ? dayjs(effectiveDate).format("DD-MM-YYYY") : "-"}
                </p>
                {(isUpdateMode || viewOnly) && user?.type !== "employee" && (
                  <p>
                    <strong>Assigned To:</strong>{" "}
                    {
                      employees.find((emp) => emp._id === assignedTo)?.userName || "-"
                    }
                  </p>
                )}
              </div>
            ) : (
              <>
                <div className={styles.inputGroup}>
                  <label className={styles.inputLabel}>Pre Order Date</label>
                  <DatePicker
                    disabled={viewOnly}
                    selected={
                      effectiveDate ? dayjs(effectiveDate, "YYYY-MM-DD").toDate() : null
                    }
                    onChange={(date) =>
                      setEffectiveDate(dayjs(date).format("YYYY-MM-DD"))
                    }
                    dateFormat="MM.dd.yyyy"
                    minDate={new Date()}
                    placeholderText="Select date"
                    className={styles.input}
                    wrapperClassName={styles.fullWidthDatepicker}
                  />
                </div>

                {(isUpdateMode || viewOnly) && user?.type !== "employee" && (
                  <div className={styles.inputGroup}>
                    <label className={styles.inputLabel}>Assigned To</label>
                    <select
                      className={styles.inputs}
                      value={assignedTo}
                      onChange={(e) => setAssignedTo(e.target.value)}
                      disabled={viewOnly}
                    >
                      <option value="">Select Employee</option>
                      {employees.map((emp) => (
                        <option key={emp._id} value={emp._id}>
                          {emp.userName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </>
            )}






            {!viewOnly && !isUpdateMode && (
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Delivery Option</label>
                <select
                  className={styles.inputs}
                  value={deliveryOption}
                  onChange={(e) => setDeliveryOption(e.target.value)}
                  required
                >
                  <option value="">Select Delivery Option</option>
                  <option value="pickup">Own delivery pickup</option>
                  <option value="shipping">Send by store</option>
                  <option value="third-party logistics">Third-Party Logistics</option>
                </select>
              </div>
            )}
          </div>

          <div className={styles.formRight}>
            <p><strong>Order From</strong></p>
            <p><strong>Item Owner:</strong> {userData?.firstName} {userData?.lastName}</p>
            <p><strong>Address:</strong> {userData?.address}</p>
            <p><strong>Phone No:</strong> {userData?.phone}</p>
          </div>
        </div>

        <div className={styles.tableHeader}>
          {!viewOnly && (
            <button className={styles.addBtn} onClick={handleAddItem}>+ Add Item</button>
          )}
        </div>



        <div className={styles.tableSection}>
          <table>
            <thead>
              <tr>
                <th><input type="checkbox" /></th>
                <th>Order Seq No</th>
                <th>Item Category</th>
                <th>Item Scales</th>
                <th>Product Type</th>
                <th>Item Quantity(Kg)</th>
                <th>Item Count</th>
                {!viewOnly && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {paginatedItems.length === 0 ? (
                <tr><td colSpan={8}>No items added</td></tr>
              ) : (
                paginatedItems.map((item, index) => (
                  <tr key={index}>
                    <td><input type="checkbox" /></td>
                    <td>O{startIndex + index + 1}</td>
                    <td>{item.itemName}</td>
                    <td>{item.productBag}</td>
                    <td>{item.productType}</td>

                    {/* <td>
                      {item.productBag === 'kilogram' ? (
                        viewOnly ? (
                          item.productQuantity ?? '-'
                        ) : (
                          <input
                            type="number"
                            min="1"
                            className={styles.tableInput}
                            value={item.productQuantity ?? ''}
                            onChange={(e) =>
                              handleQuantityChange(startIndex + index, 'productQuantity', e.target.value)
                            }
                          />
                        )
                      ) : (
                        '-'
                      )}
                    </td>

                    <td>
                      {item.productBag !== 'kilogram' ? (
                        viewOnly ? (
                          item.productCount ?? '-'
                        ) : (
                          <input
                            type="number"
                            min="1"
                            className={styles.tableInput}
                            value={item.productCount ?? ''}
                            onChange={(e) =>
                              handleQuantityChange(startIndex + index, 'productCount', e.target.value)
                            }
                          />
                        )
                      ) : (
                        '-'
                      )}
                    </td> */}

                    <td>
                      {item.productBag === 'kilogram' ? (
                        viewOnly ? (
                          item.productQuantity ?? '-'
                        ) : (
                          <input
                            type="number"
                            min="0"
                            className={styles.tableInput}
                            value={item.productQuantity}
                            onChange={(e) =>
                              handleQuantityChange(startIndex + index, 'productQuantity', e.target.value)
                            }
                          />
                        )
                      ) : (
                        '-'
                      )}
                    </td>

                    <td>
                      {item.productBag !== 'kilogram' ? (
                        viewOnly ? (
                          item.productCount ?? '-'
                        ) : (
                          <input
                            type="number"
                            min="0"
                            className={styles.tableInput}
                            value={item.productCount}
                            onChange={(e) =>
                              handleQuantityChange(startIndex + index, 'productCount', e.target.value)
                            }
                          />
                        )
                      ) : (
                        '-'
                      )}
                    </td>


                    {!viewOnly && (
                      <td className={styles.actions}>
                        <FaEdit
                          className={styles.icon}
                          title="Edit"
                          onClick={() => handleEditItem(startIndex + index)}
                        />
                        <FaTrash
                          className={styles.icon}
                          title="Delete"
                          onClick={() => handleDelete(startIndex + index)}
                        />
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>

          </table>

          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>

          <DeleteConfirmModal
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            onConfirm={confirmDelete}
          />
        </div>


        {/* <div className={styles.footerButtons}>
          <button className={styles.cancel} onClick={handleClose}>Cancel</button>
          {!viewOnly && (
            <button className={styles.save} onClick={handleSave} disabled={isCreating || isUpdating}>
              {isCreating || isUpdating ? 'Saving...' : isUpdateMode ? 'Update' : 'Save'}
            </button>
          )}
        </div> */}
        <div className={styles.footerButtons}>
          <button className={styles.cancel} onClick={handleClose}>Cancel</button>
          {!viewOnly && (
            <button
              className={styles.saves}
              onClick={handleSaveClick}
              disabled={isCreating || isUpdating}
            >
              {isCreating || isUpdating ? 'Saving...' : isUpdateMode ? 'Update the order' : 'Submit the order'}
            </button>
          )}
        </div>
      </div>

      <DeleteConfirmModalLogout
        isOpen={confirmModalOpen}
        title="Are you sure?"
        heading="Confirm Order Save"
        content="Save or review the items before approval. Once saved, you cannot undo this action. Do you want to continue?"
        onCancel={() => setConfirmModalOpen(false)}
        onConfirm={handleConfirmSave}
      />
      {showAddItemPopup && (
        <PopupWrapper onClose={() => setShowAddItemPopup(false)}>
          <AddItem
            popupMode={true}
            closePopup={() => setShowAddItemPopup(false)}
            passedState={popupProps}
            onItemUpdate={() => {
              if (isUpdateMode) {
                refetchOrder();
              } else {
                const updated = JSON.parse(localStorage.getItem('orderItems') || '[]');
                setOrderItems(updated);
              }
            }}
          />
        </PopupWrapper>
      )}

    </div>
  );
};

export default CreateOrders;








